/*
 * @Author: Teemo Ding
 * @Date: 2021-05-27 11:30:54
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-12 15:10:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/Components/FeaturedImage/Image.tsx
 */
import { Uploader } from '@/src/components';
import Row from '@/src/components/Layouts/Row/Row';
import { useSingleImageEffect } from '@/src/components/Upload';
import _ from 'lodash';
import React from 'react';
import { SectionContent } from 'src/layout/EditorPageLayout/EditorCollapsePageLayout';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import { EnumCollapseId } from '../../common';
import { getCollapse, onCollapseChange } from '../../slice/edit';

import { getI18nFromGeneral } from '@/src/tools/tools';
import css from './css.less';

const Images = (props) => {
  const { featuredImage: value, disabled, onChange } = props;

  const [fileList, setFileList] = React.useState(value ? [value] : []);
  useSingleImageEffect(value, fileList, setFileList);

  return (
    <SectionContent>
      <Row
        containerClassName={css.container}
        elements={[
          {
            child: (
              <Uploader
                height={180}
                width={'auto'}
                multiple={false}
                fileList={fileList}
                imageWidth={180}
                disabled={disabled}
                onChange={(imgArr = []) => {
                  setFileList(imgArr);
                  if (onChange) {
                    const _l = _.last(imgArr);
                    onChange(_l);
                  }
                }}
              />
            ),
          },
        ]}
      />
    </SectionContent>
  );
};
export default SectionHOC(Images, {
  id: EnumCollapseId.FeaturedImage,
  title: getI18nFromGeneral('general.hOCTitle.featureImage'),
  getCollapse,
  onCollapseChange,
});
